type EventParams = Record<string, unknown>

const gtmId = import.meta.env.VITE_GTM_ID

export function isGtmEnabled() {
  return Boolean(gtmId)
}

export function trackEvent(event: string, params: EventParams = {}) {
  if (
    !isGtmEnabled() ||
    typeof window === 'undefined' ||
    !window.__NXT_GTM_INITIALIZED__
  ) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    ...params,
  })
}

export function trackPanelView(panelId: string, panelName: string, panelIndex: number) {
  trackEvent('panel_view', {
    panel_id: panelId,
    panel_name: panelName,
    panel_index: panelIndex,
  })
}
